
export class AppConstant {
    public static DATE_FORMAT = 'dd-mm-yy';
    public static SECRET_KEY = '8XClgyqCGsxte1qVPamMSo30WbGqWWhu';
    public static TITLE = 'Dental';
    public static ORG_NAME = 'Dental';
    public static DEFAULT_LOGIN: 'OTP' | 'PASSWORD' | 'BOTH' = 'PASSWORD';
    static LOGO_SRC = 'assets/images/logo.jpeg';
    static DEFAULT_PROFILE_URL = 'assets/images/avatar.png';
    static DEFAULT_GROUP_IMAGE_URL = 'assets/images/grp-avatar.png';
    static DEFAULT_LOGO_IMAGE_URL = 'assets/images/default-logo.png';
    static MAX_IMAGE_UPLOAD_SIZE = 1000000; //1mb
    static MAX_FILE_UPLOAD_SIZE = 2000000; // 2mb
    static MAX_VIDEO_UPLOAD_SIZE = 5000000; //5mb
    static DEFAULT_PROFILE_IMAGE = 'assets/images/blank-profile-picture.png';
    static DEFAULT_GROUP_IMAGE = 'assets/images/blank-profile-picture.png';
    static DEFAULT_OLD_IMAGE_APPEND = '[~@!OLDIMAGE!@~]';
    static DEFAULT_DATE_RANGE = '1940:' + new Date().getFullYear().toString();
    static DEFAULT_FUTURE_DATE_RANGE = '1960:' + (new Date().getFullYear() + 5).toString();
    public static GENDER = [
        { id: 1, genderName: 'Male' },
        { id: 2, genderName: 'Female' },
    ];
    public static TABLE_PAGE_ROWS = 10;
}
export const VALIDATOR_PATTERNS = {
    EMAIL: /^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/,
    MOBILE: /^[6-9]{1}[0-9]{9}$/,
    NUMBER: /^[0-9]+$/,
    POSITIVE_INTEGER: /\d+/,
    WHOLE_NUMBER: /^[1-9]\d*$/,
    NUMBER_FLOAT: /^[+-]?([0-9]*[.])?[0-9]+$/,
    TEXT: /^([a-zA-Z0-9+_+-]+\s)*[a-zA-Z0-9+_+-]+$/,
    TEXT_NOT_SPACE_IN_BETWEEN: /^(?=.{1,50}$)[a-zA-Z]+(?:['_.\\s][a-zA-Z]+)*$/,
    TEXT_ONLY: /^([a-zA-Z]+\s)*[a-zA-Z]+$/,
    IFC_CODE: /^[A-Z]{4}0[A-Z0-9]{6}$/,
    PINCODE: /^[1-9][0-9]{5}$/,
    AADHAR_VALIDATOR: /^[2-9]{1}[0-9]{3}[0-9]{8}$/,
    MUST_BE: function (s: number) { return new RegExp(`^.{${s}}$`) }
}
export const MODULE_NAME = {
    PATIENT: 1,
    MASTER: 2,
    USER: 3,
    INVOICE: 4,
    EXPENSE: 5,
    APPOINTMENT: 6,
    PAYMENT: 7,
    REPORT: 8
}

export const PERMISSION = {
    ADD: 1,
    UPDATE: 2,
    DELETE: 3,
    READ: 4,
    MANAGE_MEDICINE: 5,
    MANAGE_GENERAL: 6,
    MANAGE_LOCATION: 7,
    VIEW_ALL: 8,
    VIEW_LOG: 9,
    MANAGE_ROLE: 10,
    VIEW_PROFIT_LOSS: 11,
    VIEW_PATIENT_REPORT: 12,
    VIEW_INVOICE_REPORT: 13,
    APPOINTMENT_REPORT: 14,
    BULK_MESSAGE: 15,
    MANAGE_SETTING: 16
}

export const MODIFICATION_PERMISSION = {
    ADD: 1,
    UPDATE: 2,
    DELETE: 3,
    RELIVE: 4,
    MAKE_ACTIVE: 5,
    ALLOTMENT: 6,
}

export const RESPONSE_CODE = {
    SUCCESS: 200,
    VALIDATION_ERROR: 400,
    ERROR: 500,
    METHOD_ERROR: 405,
}
export const ALIVE_STATUS = [
    { id: 1, alive_statusName: 'Active', color: 'success' },
    { id: 2, alive_statusName: 'Died', color: 'danger' },
]
export const STATUS_CHILD = [
    { id: 1, childStatusName: 'Studying' },
    { id: 2, childStatusName: 'Not Studying' },
    { id: 3, childStatusName: 'Working' },
    { id: 4, childStatusName: 'Married' },
    { id: 5, childStatusName: 'Died' }
]
export const STATUS_TBL = {
    1: "Active",
    0: "In Active"
}